module.exports = __webpack_public_path__ + "static/media/decline1.ff23624d.svg";